import * as React from "react";
import { AskAboutQuery_UsStateCase } from "../../../../../../../graphql-types";
import Row from "../../../../../ui-library/column-system/row";
import Column from "../../../../../ui-library/column-system/column";
import { formatNumberDisplay } from "../../../../../../utils/format-number";
import InfectionRateChartMini from "../../../../../ui-library/daily-cases-chart/infection-rate-chart-mini";
import { AskAboutContext } from "../../../../../../site-context/ask-about-context";
import styles from "./chart-card-group.styles";

export interface StateData {
  name: string;
  latest: Pick<
    AskAboutQuery_UsStateCase,
    "date" | "averageNewCases" | "infectionRate" | "totalCases"
  >;
  data: Array<
    Pick<
      AskAboutQuery_UsStateCase,
      "date" | "averageNewCases" | "infectionRate"
    >
  >;
}

export type SortBy =
  | "A – Z"
  | "Total cases"
  | "Avg. new daily"
  | "Infection rate";

interface StateInfectionRateChartGroupProps {
  statesData: StateData[];
  sortyBy: SortBy;
  size?: number;
  isMobileInline?: boolean;
}

const StateInfectionRateChartGroup: React.FC<StateInfectionRateChartGroupProps> = ({
  statesData,
  sortyBy,
  size,
  isMobileInline,
}) => {
  const {
    store: { isMobile },
  } = React.useContext(AskAboutContext);

  let sortedStates: StateData[] = [];
  if (sortyBy === "A – Z") {
    sortedStates = statesData.sort((a, b) => {
      if (b.name < a.name) {
        return 1;
      }
      if (a.name < b.name) {
        return -1;
      }
      return 0;
    });
  }

  if (sortyBy === "Avg. new daily") {
    sortedStates = statesData.sort(
      (a, b) => b.latest.averageNewCases - a.latest.averageNewCases
    );
  }

  if (sortyBy === "Total cases") {
    sortedStates = statesData.sort(
      (a, b) => (b.latest.totalCases || 0) - (a.latest.totalCases || 0)
    );
  }

  if (sortyBy === "Infection rate") {
    sortedStates = statesData.sort(
      (a, b) => (b.latest.infectionRate || 0) - (a.latest.infectionRate || 0)
    );
  }

  const countriesToShow = size ? sortedStates.slice(0, size) : sortedStates;

  const isInline = isMobile && isMobileInline;

  return (
    <div css={styles.root}>
      <Row isInline={isInline}>
        {countriesToShow.map((s) => (
          <Column key={s.name} spanMd={3} isInline={isInline}>
            <div css={styles.countryCard}>
              <InfectionRateChartMini data={s.data} />
              <div css={styles.content}>
                <div css={styles.countryLink}>{s.name}</div>
                <div css={styles.detail}>
                  Infection rate{" "}
                  <span>
                    {formatNumberDisplay(s.latest.infectionRate || 0)}
                  </span>
                </div>
                <div css={styles.detail}>
                  Total cases{" "}
                  <span>{formatNumberDisplay(s.latest.totalCases || 0)}</span>
                </div>
                <div css={styles.detail}>
                  Avg new daily{" "}
                  <span>{formatNumberDisplay(s.latest.averageNewCases)}</span>
                </div>
              </div>
            </div>
          </Column>
        ))}
      </Row>
    </div>
  );
};

export default StateInfectionRateChartGroup;
